import ModalService from '@/modules/core/ui/services/ModalService';
import ClaraFeedbackConfirmModal from '@/modules/ai/components/presentational/ClaraFeedbackConfirmModal.vue';
import { ClaraConversationObject } from '@/modules/ai/models/ClaraConversationObject';
import { ClaraMessageObject } from '@/modules/ai/models/ClaraMessageObject';

export const ClaraFeedbackMixin = {
  props: {
    conversation: {
      type: ClaraConversationObject
    },
    answer: {
      type: ClaraMessageObject
    },
    alwaysShowConfirmationModal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isSavingFeedback: false,
      originalValue: null,
      originalDescription: null
    };
  },
  computed: {
    answerToEdit() {
      return this.answer;
    }
  },
  methods: {
    onRate(value) {
      this.originalValue = this.feedback.value;
      this.originalDescription = this.feedback.description;

      if (this.feedback.value === value) {
        return;
      }

      this.feedback.value = value;

      if (this.alwaysShowConfirmationModal || this.feedback.isNegative) {
        this.showConfirmationModal();
        return;
      }

      this.submitFeedback();
    },
    showConfirmationModal() {
      ModalService.show({
        parent: this,
        component: ClaraFeedbackConfirmModal,
        props: {
          feedback: this.feedback,
          confirmFn: () => {
            ModalService.close();
            this.submitFeedback();
          },
          cancelFn: () => {
            ModalService.close();
            this.feedback.value = this.originalValue;
            this.feedback.description = this.originalDescription;
          }
        }
      });
    }
  }
};
